import { useQuery } from "react-query";
import LoadingApiClient from "api/LoadingApiClient";

export function useSportObjectLoading(sportObjectId) {
    return useQuery(["SportObjectLoading", { sportObjectId }], () =>
        LoadingApiClient.getSportObjectLoading(sportObjectId),
    );
}
